import React from 'react';

const SingleChoiceSelectField = ({field, choices}) => {
    return (
        <>
            <select onChange={field.onChange} value={field.value || ''} name={field.name} className="form-control">
                <option value="" />
                { choices.map((c, i) => (
                    <option className="custom-control custom-radio" key={i} value={c.id}>
                        {c.value}
                    </option>
                )) }
            </select>
        </>
    );
};

export default SingleChoiceSelectField;
